/**
 * The Settings page's topic tabs — in core because the *route* carries them (`links/routes.ts`),
 * exactly as the channel page's tabs are (`channel/tabs.ts`): a tab is a destination somebody links
 * to and the back button has to honour, not screen state.
 *
 * Five tabs, each with more than a control or two — the bar for a tab earning its place:
 *
 * - `playback` — how video plays: quality, speed, codec, autoplay, resume, the two track languages
 *   and the DRC opt-in. The default tab, because it is the one readers come back for.
 * - `interface` — what the app shows and how it looks: theme, language, menu sections, landing
 *   page, content region, page size, the watch-history mirror.
 * - `integrations` — services besides the instance. SponsorBlock is the first, and its
 *   per-category grid alone clears the bar for a tab of its own.
 * - `instance` — which Invidious the app talks to, the probe, and where the account's settings
 *   stand (the sync status lives here because the *instance* is what it is about).
 * - `data` — the clear buttons: what this browser and the account are holding, and how to drop it.
 */
export type SettingsTab = 'playback' | 'interface' | 'integrations' | 'instance' | 'data';

export const SETTINGS_TABS: readonly SettingsTab[] = [
  'playback',
  'interface',
  'integrations',
  'instance',
  'data',
];

/** What a bare `/settings` means, and what {@link SETTINGS_TABS} lists first. */
export const DEFAULT_SETTINGS_TAB: SettingsTab = 'playback';

export function isSettingsTab(value: string): value is SettingsTab {
  return (SETTINGS_TABS as readonly string[]).includes(value);
}
